module.exports = __webpack_public_path__ + "static/media/about_icon04.170edb66.png";